import client from "../client/client";
import { TOKEN } from "../utils/constants";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem(TOKEN);
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const resolveRole = (user) => {
  if (user?.is_owner) return "Propietario";
  if (user?.is_seller) return "Vendedor";
  return "Operador";
};

const getUsers = async () => {
  try {
    const resp = await client.get("user-api/search", {
      params: { page: 1, page_size: 100 },
      headers: getAuthHeaders(),
    });
    const data = resp.data;
    let items = [];
    if (Array.isArray(data)) items = data;
    else if (Array.isArray(data?.results)) items = data.results;
    else if (Array.isArray(data?.items)) items = data.items;
    else if (Array.isArray(data?.data)) items = data.data;

    return items
      // Ocultar los usuarios dados de baja (eliminados); la baja es lógica.
      .filter((u) => u.active !== false && u.active !== 0 && u.active !== "0")
      .map((u) => {
        // Mostrar el nombre real (firstname + lastname); el email solo si no hay nombre.
        const fullName = `${u.firstname ?? ""} ${u.lastname ?? ""}`.trim();
        return {
          ...u,
          name: fullName || u.email || u.name,
          role: resolveRole(u),
        };
      });
  } catch (error) {
    console.error("Error al obtener usuarios:", error);
    throw error;
  }
};

const createUser = async (data) => {
  try {
    let resp = client.post("user-api/save", data, {
      headers: getAuthHeaders(),
    });
    return await resp;
  } catch (error) {
    console.error("Error al crear el usuario:", error);
    throw error;
  }
};

const postUpdateUsuario = async (data) => {
  let resp = client.put("user-api/update-profile", data);
  return await resp;
};

// Actualiza un colaborador (rol, permisos, datos). Requiere el id del usuario.
const updateUser = async (data) => {
  const resp = await client.put("user-api/update", data, {
    headers: getAuthHeaders(),
  });
  return await resp;
};

// Baja lógica de un colaborador (no hay delete duro en el backend).
const deactivateUser = async (id) => {
  const resp = await client.patch(`user-api/user/${id}/deactivate`, {}, {
    headers: getAuthHeaders(),
  });
  return await resp;
};

const getAllUsuarios = async () => {
  let resp = client.get("users/register/", {
    sku: "",
  });

  return resp;
};

const deleteUsuario = async (data) => {
  let resp = client.delete("users/register/", { data });
  return await resp;
};

const getDeposits = async () => {
  const userId = sessionStorage.getItem("User");
  try {
    const resp = await client.get(`warehouse-api/search/${userId}`);
    return resp;
  } catch (error) {
    console.error("Error al obtener productos por SKU:", error);
    throw error;
  }
};

const getProfile = async () => {
  const userId = sessionStorage.getItem("User");
  try {
    const resp = await client.get(`user-api/user/${userId}`);
    return resp;
  } catch (error) {
    console.error("Error al obtener perfil:", error);
  }
};

const getPermits = async () => {
  try {
    const resp = await client.get("user-api/permissions");
    return resp;
  } catch (error) {
    console.error("Error al obtener perfil:", error);
  }
};

let userService = {
  getUsers,
  createUser,
  getAllUsuarios,
  deleteUsuario,
  postUpdateUsuario,
  updateUser,
  deactivateUser,
  getDeposits,
  getProfile,
  getPermits,
};

export default userService;
